import React from "react";
import { SessionStatus, statusColor } from "../mockData";
import { CheckCircle2, Loader2, Clock, AlertTriangle } from "lucide-react";

const ICON: Record<SessionStatus, React.ComponentType<{ className?: string }>> = {
  processed:  CheckCircle2,
  processing: Loader2,
  queued:     Clock,
  failed:     AlertTriangle,
};

const LABEL: Record<SessionStatus, string> = {
  processed:  "Processed",
  processing: "Processing",
  queued:     "Queued",
  failed:     "Failed",
};

export function StatusBadge({ status }: { status: SessionStatus }) {
  const Icon = ICON[status];
  return (
    <span className={`badge ${statusColor(status)}`}>
      <Icon className={`h-3 w-3 ${status === "processing" ? "animate-spin" : ""}`} />
      {LABEL[status]}
    </span>
  );
}
